import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    
`

export const Wrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    @media (max-width: 1040px){
        max-width: 768px;
    }
    @media (max-width: 808px){
        max-width: 400px;
        padding: 0 20px;
    }
`

export const Title = styled.h1`
    margin-top: 50px;
    text-align: center;
`

export const Text = styled.h2`
    font-weight: 500;
    color: rgba(0, 0, 0, 0.54);
    text-align: center;
    margin-bottom: 50px;
`

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-gap: 20px;
    align-items: start;
    @media (max-width: 1040px){
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-gap: 20px;
        align-items: start;
    }
    @media (max-width: 806px){
        max-width: 400px;
        width: 100%;
        grid-template-columns: 1fr;
        grid-gap: 20px;
        align-items: start;
        
    }
    
`

export const ImageWrapper = styled.div`
    position: relative;
    transition: 0.8s all ease;
    

    &:hover > .animacija{
        height: 40%;
        transition: 0.8s all ease;

    }
`

export const Image = styled.div`
    width: 100%;
    height: 320px;
    & > img{
        width: 100%;
        height: 320px;
        object-fit: cover;
    }
    @media (max-width: 1040px){
        width: 100%;
        height: 300px;
        & > img{
            width: 100%;
            height: 300px;
            object-fit: cover;
        }
    }
    @media (max-width: 806px){
        width: 100%;
        height: 80vw;
        max-height: 400px;
        & > img{
            width: 100%;
            max-width: 400px;
            max-height: 400px;
            height: 100%;
            object-fit: cover;
        }
    }
`

export const DescContainer = styled.div`
    padding: 0 20px;
    width: 100%;
    height: 0;
    background: rgba(6, 12, 34, 0.76);
    color: white;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    transition: 0.8s all ease;

    @media (max-width: 1400px){
        height: 40%;
    }
    
    
`

export const DescName = styled.p`
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 10px;
    margin-block-end: 0;
`

export const Description = styled.p`
    margin-block-start: 0;
    margin-block-end: 0;
`